const sanpham = [
  {
    id: '1',
    tenSanPham: 'Bùa cầu an',
    hinhAnh: [require('../images/imageChat/sp1.jpeg')],
    moTa: 'Bùa cầu an của người Dao đỏ, ban đầu là túi thảo dược chữa bệnh cho trẻ em, nay mang ý nghĩa cầu bình an, may mắn.',
    gia: 60000,
    loaiSanPham: 'Bùa',
    nguoiBan: {
      ten: 'Quỳnh',
      sdt: '0334966693',
      diaChi: 'Tổ 1 Phường Tân Giang, Tỉnh Cao Bằng'
    },
    xuatXu: 'Cao Bằng',
    tinhTrang: 'Mới',
    cauChuyen: 'Sản phẩm bùa cầu an của người Dao đỏ gắn với bộ phim “Đi giữa trời rực rỡ”. Ban đầu, sản phẩm là dạng túi chứa thảo dược chữa bệnh cam (bệnh còi cọc, tóc dựng, khó nuôi) của trẻ con, dạng nhỏ thường được đeo ở cổ. Với ý nghĩa đó, sản phẩm sau này đã phát triển thành bùa cầu an với họa tiết hoa văn mang theo ý nghĩa cầu mong bình an, may nắm cho người sở hữu.'
  },
  {
    id: '2',
    tenSanPham: 'Móc khóa Mông',
    hinhAnh: [require('../images/imageChat/sp2.jpeg')],
    moTa: 'Móc treo làm từ vải đay, dệt và nhuộm màu tự nhiên, thêu họa tiết xoắn ốc, quả núi đặc trưng của người Mông.',
    gia: 40000,
    loaiSanPham: 'Móc khóa',
    nguoiBan: {
      ten: 'Quỳnh',
      sdt: '0334966693',
      diaChi: 'Tổ 1 Phường Tân Giang, Tỉnh Cao Bằng'
    },
    xuatXu: 'Cao Bằng',
    tinhTrang: 'Mới',
    cauChuyen: 'Sản phẩm móc treo được làm từ vải đay. Quá trình sản xuất được những người thợ thủ công khéo tay dệt từ sợi đay thành tấm vải trắng, nhuộm màu tự nhiên, sau đó thêu những họa tiết hoa văn của dân tộc mình. Các họa tiết trên móc treo gắn với: hình xoắn ốc, hình quả núi,.. và cỏ cây, hoa lá, các loại vật.'
  },
  {
    id: '3',
    tenSanPham: 'Búp bê Tày',
    hinhAnh: [require('../images/imageChat/sp3.jpeg')],
    moTa: 'Búp bê Tày mặc trang phục vải chàm, đi kèm vòng cổ, chuông và túi thổ cẩm, tái hiện văn hóa Tày - Cao Bằng.',
    gia: 200000,
    loaiSanPham: 'Búp bê',
    nguoiBan: {
      ten: 'Quỳnh',
      sdt: '0334966693',
      diaChi: 'Tổ 1 Phường Tân Giang, Tỉnh Cao Bằng'
    },
    xuatXu: 'Cao Bằng',
    tinhTrang: 'Mới',
    cauChuyen: 'Búp bê Tày được may bằng chất liệu vải chàm do bà con người Nùng ở thị trấn Quảng Uyên nhuộm nên. Bộ trang phục được may dựa trên ý tưởng của bộ trang phục gốc. Ngoài trang phục, búp bê còn được đeo vòng cổ, gắn chuông trên họa tiết áo và đeo túi xách thổ cẩm nhằm tạo nên một câu chuyện văn hóa của người Tày – Cao Bằng. (Dân tộc Tày chiếm 40,83%, có tỉ lệ dân số đông nhất ở Cao Bằng)'
  },
  {
    id: '4',
    tenSanPham: 'Búp bê Nùng',
    hinhAnh: [require('../images/imageChat/sp4.jpeg')],
    moTa: 'Búp bê mặc trang phục của người Nùng Giang - Hà Quảng, chất liệu vải chàm, nổi bật với chiếc khăn đội đầu rực rỡ.',
    gia: 200000,
    loaiSanPham: 'Búp bê',
    nguoiBan: {
      ten: 'Quỳnh',
      sdt: '0334966693',
      diaChi: 'Tổ 1 Phường Tân Giang, Tỉnh Cao Bằng'
    },
    xuatXu: 'Cao Bằng',
    tinhTrang: 'Mới',
    cauChuyen: 'Búp bê Nùng Giang (được may bằng chất liệu vải chàm do bà con người Nùng ở thị trấn Quảng Uyên nhuộm nên. Bộ trang phục được may dựa trên ý tưởng của bộ trang phục gốc của người Nùng Giang – huyện Hà Quảng. Bộ trang phục được kết hợp với chiếc khăn đội đầu có mày sắc rực rỡ như tôn lên vẻ đẹp của khuôn mặt người phụ nữ. (Dân tộc Nùng chiếm 29,81% dân số toàn tỉnh, có số dân đông thứ hai sau dân tộc Tày.)'
  },
  {
    id: '5',
    tenSanPham: 'Búp bê Mông thường',
    hinhAnh: [require('../images/imageChat/sp5.jpeg')],
    moTa: 'Búp bê Mông với trang phục từ vải kim sa óng ánh và chân váy lanh, thể hiện sự dịu dàng, nữ tính.',
    gia: 200000,
    loaiSanPham: 'Búp bê',
    nguoiBan: {
      ten: 'Quỳnh',
      sdt: '0334966693',
      diaChi: 'Tổ 1 Phường Tân Giang, Tỉnh Cao Bằng'
    },
    xuatXu: 'Cao Bằng',
    tinhTrang: 'Mới',
    cauChuyen: 'Búp bê Mông thường được may bằn chất liệu vải kim sa óng ánh và vải lanh làm chân váy thể hiện sự dịu dàng nữ tính. Màu sắc trang phục xanh lá và trắng như tôn thêm đường nét của người phụ nữ Mông. (Dân tộc Mông chiếm 11,65% dân số toàn tỉnh)'
  },
  {
    id: '6',
    tenSanPham: 'Búp bê Mông thêu',
    hinhAnh: [require('../images/imageChat/sp6.jpeg')],
    moTa: 'Búp bê Mông mặc trang phục vải chàm và lanh, nổi bật với các họa tiết hoa văn thêu tay tinh xảo.',
    gia: 250000,
    loaiSanPham: 'Búp bê',
    nguoiBan: {
      ten: 'Quỳnh',
      sdt: '0334966693',
      diaChi: 'Tổ 1 Phường Tân Giang, Tỉnh Cao Bằng'
    },
    xuatXu: 'Cao Bằng',
    tinhTrang: 'Mới',
    cauChuyen: 'Búp bê Mông thêu được may bằng chất liệu vải chàm và vải lanh làm chân váy thể hiện bản sắc riêng có. Kết hợp với các họa tiết hoa văn ở phần cổ áo, ngực áo và thắt lưng như một câu chuyện văn hóa mà người nghệ nhân muốn chia sẻ cho khách hàng.'
  },
  {
    id: '7',
    tenSanPham: 'Búp bê Dao đỏ',
    hinhAnh: [require('../images/imageChat/sp7.jpeg')],
    moTa: 'Búp bê mặc trang phục Dao đỏ, may từ vải nhung và len, phom dáng cứng cáp, màu đen và đỏ chủ đạo.',
    gia: 250000,
    loaiSanPham: 'Búp bê',
    nguoiBan: {
      ten: 'Quỳnh',
      sdt: '0334966693',
      diaChi: 'Tổ 1 Phường Tân Giang, Tỉnh Cao Bằng'
    },
    xuatXu: 'Cao Bằng',
    tinhTrang: 'Mới',
    cauChuyen: 'Búp bê mặc trang phục Dao đỏ được may trên chất liệu nhung thổ và len. Chất vải đứng phom dáng áo vừa toát ra sự mềm mượt, lại vừa thể hiện được các đường nét cứng cáp mà vẫn tinh tế, uyển chuyển trên trang phục. Màu sắc chủ đạo là đen và đỏ - hút mắt khách hàng. (Dân tộc Dao chiếm 10,36% dân số toàn tỉnh)'
  },
  {
    id: '8',
    tenSanPham: 'Búp bê Dao Tiền',
    hinhAnh: [require('../images/imageChat/sp8.jpeg')],
    moTa: 'Búp bê Dao Tiền, vải chàm nhuộm thủ công, chân váy chấm họa tiết sáp ong độc đáo hình bánh xe hoặc sóng nước.',
    gia: 250000,
    loaiSanPham: 'Búp bê',
    nguoiBan: {
      ten: 'Quỳnh',
      sdt: '0334966693',
      diaChi: 'Tổ 1 Phường Tân Giang, Tỉnh Cao Bằng'
    },
    xuatXu: 'Cao Bằng',
    tinhTrang: 'Mới',
    cauChuyen: 'Búp bê Dao Tiền được may bằng chất liệu vải chàm do bà con người Dao tiền ở xã Quang Thành, huyện Nguyên Bình nhuộm nên. Bộ trang phục được may dựa trên ý tưởng của bộ trang phục gốc, phần chân váy của người Dao tiền được chấm họa tiết hoa văn bằng sáp ong hình bánh xe hoặc sóng nước (gắn với câu chuyện Bàn Vương – vị vua của họ), rồi mới nhuộm chàm. Phần khăn đội đầu màu trắng, kết hợp với nhưng lắc chuông nhỏ làm cho sản phẩm trở nên sống động hơn. Trang sức của họ là những hạt cườm nhiều màu sắc được sâu thành vòng nhằm làm tăng thêm điểm nhấn sắc màu cho trang phục. Đây chính là câu chuyện văn hóa của người thợ thủ công Dao tiền muốn chia sẻ đến với khách hàng.'
  },
  {
    id: '9',
    tenSanPham: 'Búp bê Lô Lô',
    hinhAnh: [require('../images/imageChat/sp9.jpeg')],
    moTa: 'Búp bê Lô Lô đen với trang phục hở rốn, áo dáng ngắn, tay áo phối màu sặc sỡ, mang hơi hướng thời trang.',
    gia: 250000,
    loaiSanPham: 'Búp bê',
    nguoiBan: {
      ten: 'Quỳnh',
      sdt: '0334966693',
      diaChi: 'Tổ 1 Phường Tân Giang, Tỉnh Cao Bằng'
    },
    xuatXu: 'Cao Bằng',
    tinhTrang: 'Mới',
    cauChuyen: 'Búp bê Lô Lô đen được may bằng chất liệu vải chàm do bà con người Nùng ở thị trấn Quảng Uyên nhuộm nên. Bộ trang phục được may dựa trên ý tưởng của bộ trang phục gốc. Điểm nhấn của bộ trang phục là hở rốn với áo dáng ngắn, quần dài và đai lưng. Phần tay áo được trang trí bởi những khúc vải sắc màu sặc sỡ tạo dấu ấn riêng. Trong những bộ trang phục các dân tộc ở Cao Bằng, trang phục lô lô được khách hàng đánh giá là trang phục mang hơi hướng thời trang nhất. (Dân tộc Lô Lô đen chiếm 0,54% dân số toàn tỉnh. Theo thống kê, dân tộc Lô Lô đen là dân tộc rất ít người, có dân số dưới 10.000 người ở Việt Nam)'
  },
  {
    id: '10',
    tenSanPham: 'Búp bê Sán Chỉ',
    hinhAnh: [require('../images/imageChat/sp10.jpeg')],
    moTa: 'Búp bê Sán Chỉ với trang phục màu đen chủ đạo, điểm nhấn là dải yếm sợi màu sắc và trang sức bạc.',
    gia: 200000,
    loaiSanPham: 'Búp bê',
    nguoiBan: {
      ten: 'Quỳnh',
      sdt: '0334966693',
      diaChi: 'Tổ 1 Phường Tân Giang, Tỉnh Cao Bằng'
    },
    xuatXu: 'Cao Bằng',
    tinhTrang: 'Mới',
    cauChuyen: 'Búp bê Sán Chỉ được may dựa trên ý tưởng bộ trang phục gốc với màu đen là màu sắc chủ đạo. Điểm nhất trên trang phục là dải yếm sợi màu sắc và trang sức bạc.'
  },
  {
    id: '11',
    tenSanPham: 'Búp bê Kinh',
    hinhAnh: [require('../images/imageChat/sp11.jpeg')],
    moTa: 'Búp bê dân tộc Kinh duyên dáng trong tà Áo dài truyền thống, toát lên vẻ nhẹ nhàng và thanh tao.',
    gia: 200000,
    loaiSanPham: 'Búp bê',
    nguoiBan: {
      ten: 'Quỳnh',
      sdt: '0334966693',
      diaChi: 'Tổ 1 Phường Tân Giang, Tỉnh Cao Bằng'
    },
    xuatXu: 'Cao Bằng',
    tinhTrang: 'Mới',
    cauChuyen: 'Búp bê dân tộc Kinh mặc trang phục Áo dài truyền thống nhẹ nhàng và thanh tao'
  },
  {
    id: '12',
    tenSanPham: 'Búp bê nam Tày, Nùng',
    hinhAnh: [require('../images/imageChat/sp12.jpeg')],
    moTa: 'Búp bê nam mặc trang phục chàm truyền thống của người Tày, Nùng, may từ vải chàm nhuộm thủ công.',
    gia: 200000,
    loaiSanPham: 'Búp bê',
    nguoiBan: {
      ten: 'Quỳnh',
      sdt: '0334966693',
      diaChi: 'Tổ 1 Phường Tân Giang, Tỉnh Cao Bằng'
    },
    xuatXu: 'Cao Bằng',
    tinhTrang: 'Mới',
    cauChuyen: 'Búp bê nam Nùng được may dựa trên chất liệu chàm do bà con người Nùng ở thị trấn Quảng Uyên nhuộm nên.'
  },
  {
    id: '13',
    tenSanPham: 'Khăn thổ cẩm',
    hinhAnh: [require('../images/imageChat/sp13.jpeg')],
    moTa: 'Khăn phối hợp giữa vải chàm và thổ cẩm Tày, màu sắc sặc sỡ, dễ phối đồ, thích hợp cho các dịp lễ, tết.',
    gia: 250000,
    loaiSanPham: 'Khăn',
    nguoiBan: {
      ten: 'Quỳnh',
      sdt: '0334966693',
      diaChi: 'Tổ 1 Phường Tân Giang, Tỉnh Cao Bằng'
    },
    xuatXu: 'Cao Bằng',
    tinhTrang: 'Mới',
    cauChuyen: 'Khăn được kết hợp giữa vải chàm và vải dệt thổ cẩm tạo ra câu chuyện riêng về văn hóa người Tày mà nghệ nhân muốn chia sẻ đến khách hàng. Chiếc khăn sặc sỡ rất dễ phối với áo Tày hay áo dài – đây là sản phẩm thích hợp để chị em dùng chụp ảnh trong các dịp tết, lễ.'
  },
  {
    id: '14',
    tenSanPham: 'Túi rút Tày',
    hinhAnh: [require('../images/imageChat/sp14.jpeg')],
    moTa: 'Túi rút nhỏ gọn, kết hợp hoa văn dệt thổ cẩm Tày và vải kaki hoặc chàm, xinh xắn và tiện dụng.',
    gia: 150000,
    loaiSanPham: 'Túi',
    nguoiBan: {
      ten: 'Quỳnh',
      sdt: '0334966693',
      diaChi: 'Tổ 1 Phường Tân Giang, Tỉnh Cao Bằng'
    },
    xuatXu: 'Cao Bằng',
    tinhTrang: 'Mới',
    cauChuyen: 'Loại túi kết hợp hoa văn dệt thổ cẩm Tày và vải kaki (hoặc chàm) nhỏ gọn xinh xắn.'
  },
  {
    id: '15',
    tenSanPham: 'Túi rút đeo chéo',
    hinhAnh: [require('../images/imageChat/sp15.jpeg')],
    moTa: 'Túi đeo chéo chất liệu chàm nguyên gốc, kết hợp họa tiết thổ cẩm hoặc dòng chữ "Non nước Cao Bằng".',
    gia: 150000,
    loaiSanPham: 'Túi',
    nguoiBan: {
      ten: 'Quỳnh',
      sdt: '0334966693',
      diaChi: 'Tổ 1 Phường Tân Giang, Tỉnh Cao Bằng'
    },
    xuatXu: 'Cao Bằng',
    tinhTrang: 'Mới',
    cauChuyen: 'Sản phẩm túi sử dụng chất liệu chàm nguyên gốc kết hợp hoa văn thổ cẩm độc đáo hoặc dòng chữ Non nước Cao Bằng để làm tôn vinh họa tiết hoa văn độc đáo của người dân bản địa.'
  },
  {
    id: '16',
    tenSanPham: 'Túi Ipad thổ cẩm',
    hinhAnh: [require('../images/imageChat/sp16.jpeg')],
    moTa: 'Túi đựng Ipad chất liệu chàm, kết hợp hoa văn thổ cẩm độc đáo, bảo vệ thiết bị và thể hiện phong cách.',
    gia: 150000,
    loaiSanPham: 'Túi',
    nguoiBan: {
      ten: 'Quỳnh',
      sdt: '0334966693',
      diaChi: 'Tổ 1 Phường Tân Giang, Tỉnh Cao Bằng'
    },
    xuatXu: 'Cao Bằng',
    tinhTrang: 'Mới',
    cauChuyen: 'Sản phẩm túi sử dụng chất liệu chàm nguyên gốc kết hợp hoa văn thổ cẩm độc đáo để làm tôn vinh họa tiết hoa văn độc đáo của người dân bản địa.'
  },
  {
    id: '17',
    tenSanPham: 'Túi trống nhỏ cầm tay',
    hinhAnh: [require('../images/imageChat/sp17.jpeg')],
    moTa: 'Túi hình trống nhỏ cầm tay, chất liệu chàm nguyên gốc kết hợp hoa văn thổ cẩm độc đáo và tinh tế.',
    gia: 150000,
    loaiSanPham: 'Túi',
    nguoiBan: {
      ten: 'Quỳnh',
      sdt: '0334966693',
      diaChi: 'Tổ 1 Phường Tân Giang, Tỉnh Cao Bằng'
    },
    xuatXu: 'Cao Bằng',
    tinhTrang: 'Mới',
    cauChuyen: 'Sản phẩm túi sử dụng chất liệu chàm nguyên gốc kết hợp hoa văn thổ cẩm độc đáo để làm tôn vinh họa tiết hoa văn độc đáo của người dân bản địa.'
  },
  {
    id: '18',
    tenSanPham: 'Túi Tày nguyên gốc',
    hinhAnh: [require('../images/imageChat/sp18.jpeg')],
    moTa: 'Túi dệt thổ cẩm Tày hai mặt, kết hợp dòng chữ “Non nước Cao Bằng”, khẳng định vẻ đẹp và sự khéo léo.',
    gia: 250000,
    loaiSanPham: 'Túi',
    nguoiBan: {
      ten: 'Quỳnh',
      sdt: '0334966693',
      diaChi: 'Tổ 1 Phường Tân Giang, Tỉnh Cao Bằng'
    },
    xuatXu: 'Cao Bằng',
    tinhTrang: 'Mới',
    cauChuyen: 'Túi dệt thổ cẩm Tày hai mặt, kết hợp với dòng chữ “Non nước Cao Bằng” như khẳng định vẻ đẹp non nước hữu tình của vùng đất Cao Bằng và sự khéo léo trong từng đường dệt của người thợ thủ công.'
  },
  {
    id: '19',
    tenSanPham: 'Túi đen thổ cẩm Tày đeo vai',
    hinhAnh: [require('../images/imageChat/sp19.jpeg')],
    moTa: 'Túi canvas đen hiện đại, làm nổi bật họa tiết thổ cẩm Tày hoặc dòng chữ "Non nước Cao Bằng".',
    gia: 150000,
    loaiSanPham: 'Túi',
    nguoiBan: {
      ten: 'Quỳnh',
      sdt: '0334966693',
      diaChi: 'Tổ 1 Phường Tân Giang, Tỉnh Cao Bằng'
    },
    xuatXu: 'Cao Bằng',
    tinhTrang: 'Mới',
    cauChuyen: 'Kết hợp hoa văn thổ cẩm độc đáo hoặc dòng chữ Non nước Cao Bằng trên sản phẩm túi canvats với kiểu dáng hiện đại, phù hợp với nhiều phong cách và hoàn cảnh sử dụng. Sản phẩm túi sử dụng các màu đơn sắc (Trắng, đen) để làm tôn vinh họa tiết hoa văn độc đáo của người dân bản địa.'
  },
  {
    id: '20',
    tenSanPham: 'Túi cói thổ cẩm Tày',
    hinhAnh: [require('../images/imageChat/sp20.jpeg')],
    moTa: 'Sự kết hợp mộc mạc giữa chất liệu cói tự nhiên và điểm nhấn là họa tiết thổ cẩm Tày đầy màu sắc.',
    gia: 150000,
    loaiSanPham: 'Túi',
    nguoiBan: {
      ten: 'Quỳnh',
      sdt: '0334966693',
      diaChi: 'Tổ 1 Phường Tân Giang, Tỉnh Cao Bằng'
    },
    xuatXu: 'Cao Bằng',
    tinhTrang: 'Mới',
    cauChuyen: ''
  },
  {
    id: '21',
    tenSanPham: 'Túi chàm thổ cẩm Tày đeo vai',
    hinhAnh: [require('../images/imageChat/sp21.jpeg')],
    moTa: 'Túi đeo vai hiện đại trên chất liệu chàm nguyên gốc, kết hợp họa tiết thổ cẩm hoặc các dòng chữ ý nghĩa.',
    gia: 200000,
    loaiSanPham: 'Túi',
    nguoiBan: {
      ten: 'Quỳnh',
      sdt: '0334966693',
      diaChi: 'Tổ 1 Phường Tân Giang, Tỉnh Cao Bằng'
    },
    xuatXu: 'Cao Bằng',
    tinhTrang: 'Mới',
    cauChuyen: 'Kết hợp hoa văn thổ cẩm độc đáo hoặc dòng chữ Non nước Cao Bằng, Pác Bó – Cao Bằng trên sản phẩm với kiểu dáng hiện đại, phù hợp với nhiều phong cách và hoàn cảnh sử dụng. Sản phẩm túi sử dụng chất liệu chàm nguyên gốc để làm tôn vinh họa tiết hoa văn độc đáo của người dân bản địa.'
  },
  {
    id: '22',
    tenSanPham: 'Túi đựng điện thoại đeo chéo',
    hinhAnh: [require('../images/imageChat/sp22.jpeg')],
    moTa: 'Túi nhỏ đựng điện thoại làm từ vải đay, thêu họa tiết đặc trưng của các dân tộc Mông, Nùng, Dao Tiền.',
    gia: 150000,
    loaiSanPham: 'Túi',
    nguoiBan: {
      ten: 'Quỳnh',
      sdt: '0334966693',
      diaChi: 'Tổ 1 Phường Tân Giang, Tỉnh Cao Bằng'
    },
    xuatXu: 'Cao Bằng',
    tinhTrang: 'Mới',
    cauChuyen: 'Chất liệu túi được làm từ vải đay. Quá trình sản xuất được những người thợ thủ công khéo tay dệt từ sợi đay thành tấm vải trắng, nhuộm màu tự nhiên, sau đó thêu những họa tiết hoa văn của dân tộc mình. Các họa tiết trên túi xách mang họa tiết: hình xoắn ốc, hình quả núi,.. và cỏ cây, hoa lá, các loại vật gắn liệu với cuộc sống.'
  },
  {
    id: '23',
    tenSanPham: 'Túi trống nhỏ cầm tay (Loại 2)',
    hinhAnh: [require('../images/imageChat/sp23.jpeg')],
    moTa: 'Phiên bản túi trống nhỏ cầm tay với mức giá hợp lý, vẫn giữ nguyên phom dáng độc đáo và nét văn hóa.',
    gia: 120000,
    loaiSanPham: 'Túi',
    nguoiBan: {
      ten: 'Quỳnh',
      sdt: '0334966693',
      diaChi: 'Tổ 1 Phường Tân Giang, Tỉnh Cao Bằng'
    },
    xuatXu: 'Cao Bằng',
    tinhTrang: 'Mới',
    cauChuyen: ''
  },
  {
    id: '24',
    tenSanPham: 'Vòng tay sắc màu không thêu',
    hinhAnh: [require('../images/imageChat/sp24.jpeg')],
    moTa: 'Vòng tay dệt từ những sợi chỉ nhiều màu sắc, không thêu, đơn giản mà nổi bật.',
    gia: 10000,
    loaiSanPham: 'Phụ kiện',
    nguoiBan: {
      ten: 'Quỳnh',
      sdt: '0334966693',
      diaChi: 'Tổ 1 Phường Tân Giang, Tỉnh Cao Bằng'
    },
    xuatXu: 'Cao Bằng',
    tinhTrang: 'Mới',
    cauChuyen: ''
  },
  {
    id: '25',
    tenSanPham: 'Ví tròn thêu hoa văn người Mông',
    hinhAnh: [require('../images/imageChat/sp25.jpeg')],
    moTa: 'Ví hình tròn độc đáo, thêu tay các hoa văn đặc trưng của người Mông, nhỏ gọn và tinh tế.',
    gia: 150000,
    loaiSanPham: 'Ví',
    nguoiBan: {
      ten: 'Quỳnh',
      sdt: '0334966693',
      diaChi: 'Tổ 1 Phường Tân Giang, Tỉnh Cao Bằng'
    },
    xuatXu: 'Cao Bằng',
    tinhTrang: 'Mới',
    cauChuyen: ''
  },
  {
    id: '26',
    tenSanPham: 'Túi Nùng thường',
    hinhAnh: [require('../images/imageChat/sp26.jpeg')],
    moTa: 'Túi là sự kết hợp duyên dáng giữa vải chàm với vải xanh, vải đỏ con công và thổ cẩm Nùng.',
    gia: 150000,
    loaiSanPham: 'Túi',
    nguoiBan: {
      ten: 'Quỳnh',
      sdt: '0334966693',
      diaChi: 'Tổ 1 Phường Tân Giang, Tỉnh Cao Bằng'
    },
    xuatXu: 'Cao Bằng',
    tinhTrang: 'Mới',
    cauChuyen: 'Túi nùng là sự kết hợp giữa vải chàm với vải xanh, vải đỏ con công và thổ cẩm tạo nên sự duyên dáng cho từng sản phẩm'
  },
  {
    id: '27',
    tenSanPham: 'Túi Nùng thổ cẩm',
    hinhAnh: [require('../images/imageChat/sp27.jpeg')],
    moTa: 'Phiên bản túi Nùng cao cấp hơn, tập trung vào các mảng dệt thổ cẩm lớn và tinh xảo.',
    gia: 200000,
    loaiSanPham: 'Túi',
    nguoiBan: {
      ten: 'Quỳnh',
      sdt: '0334966693',
      diaChi: 'Tổ 1 Phường Tân Giang, Tỉnh Cao Bằng'
    },
    xuatXu: 'Cao Bằng',
    tinhTrang: 'Mới',
    cauChuyen: ''
  },
  {
    id: '28',
    tenSanPham: 'Lót ly',
    hinhAnh: [require('../images/imageChat/sp28.jpeg')],
    moTa: 'Lót ly thêu tay các hoa văn đặc trưng của dân tộc Mông, Dao. Sản phẩm nhỏ gọn nhưng đầy tinh tế.',
    gia: 30000,
    loaiSanPham: 'Đồ gia dụng',
    nguoiBan: {
      ten: 'Quỳnh',
      sdt: '0334966693',
      diaChi: 'Tổ 1 Phường Tân Giang, Tỉnh Cao Bằng'
    },
    xuatXu: 'Cao Bằng',
    tinhTrang: 'Mới',
    cauChuyen: 'Lót ly thêu tay mang hoa văn đặc trưng của dân tộc Mông, Dao. Sản phẩm nhỏ gọn mang theo sự tinh tế trong từng đường nét hoa văn'
  },
  {
    id: '29',
    tenSanPham: 'Còn thêu tay',
    hinhAnh: [require('../images/imageChat/sp29.jpeg')],
    moTa: 'Quả còn trang trí họa tiết ngôi sao 8 cánh của người Mông – biểu trưng cho thần linh tối cao là mặt trời.',
    gia: 150000,
    loaiSanPham: 'Đồ trang trí',
    nguoiBan: {
      ten: 'Quỳnh',
      sdt: '0334966693',
      diaChi: 'Tổ 1 Phường Tân Giang, Tỉnh Cao Bằng'
    },
    xuatXu: 'Cao Bằng',
    tinhTrang: 'Mới',
    cauChuyen: 'Còn thêu tay mang trang trí họa tiết ngôi sao 8 cánh của người mông – hình ảnh biểu trưng mặt trời. trong văn hóa Mông mặt trời là biểu trưng cho thần linh tối cao'
  },
  {
    id: '30',
    tenSanPham: 'Còn không thêu',
    hinhAnh: [require('../images/imageChat/sp30.jpeg')],
    moTa: 'Quả còn nhiều màu sắc, lấy ý tưởng từ quả còn giao duyên của người Tày, Nùng trong các dịp lễ, tết.',
    gia: 60000,
    loaiSanPham: 'Đồ trang trí',
    nguoiBan: {
      ten: 'Quỳnh',
      sdt: '0334966693',
      diaChi: 'Tổ 1 Phường Tân Giang, Tỉnh Cao Bằng'
    },
    xuatXu: 'Cao Bằng',
    tinhTrang: 'Mới',
    cauChuyen: 'Còn trang trí mang nhiều màu sắc. sản phẩm lấy ý tưởng từ con giao duyên thường được người tày, nùng sử dụng trong các dịp tết lễ. Với mong muốn, thông qua quả còn có thể tìm được người thương trong dịp gặp gỡ.'
  }
];

export default sanpham;